import { ToastContainer } from 'react-toastify';

const Toast = () => {
  return <ToastContainer closeButton={false} hideProgressBar newestOnTop />;
};

export default Toast;
